/**
 * Formats an order date into a readable format.
 * Example output: "September 21, 2026"
 *
 * Expected input format: "DD/MM/YYYY" (e.g. "20/04/2026")
 *
 * The input string is parsed into a UTC date using Date.UTC
 * to avoid timezone-related shifts across different user locations.
 *
 * If the input is invalid or empty, it safely returns an empty string.
 */

export const formatOrderDate = (dateString) => {
    if (!dateString) return ''

    const [day, month, year] = dateString.split('/')

    const date = new Date(Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day)
    ))

    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    }).format(date)
}
